import React, {useState, useEffect} from 'react';
import {useAppSelector} from "../../lib/hooks";
import {
  IonButtons,
  IonContent,
  IonHeader, IonIcon,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar, useIonViewWillEnter
} from "@ionic/react";
import {alertCircleOutline, clipboard, document, home} from "ionicons/icons";
import {NavFooter} from "../../components/NavFooter";
import AgendaProximos from "./AgendaProximos";
import AgendaAnteriores from "./AgendaAnteriores";
import AgendaAtrasados from "./AgendaAtrasados";
import {useHistory, useLocation} from "react-router";
import qs from "qs";
import {
  buildQueryStringFromAgendaFiltros,
  getDefaultFiltros,
  IAgendaFiltros
} from "./AgendaFiltros";
import assign from "lodash/assign";

const getTabFromUrl = (locationSearch: string): string|undefined => {
  const queryString = qs.parse(locationSearch, {ignoreQueryPrefix: true});
  const {tab} = queryString;
  if (tab)
    return tab.toString();
  return undefined;
}


const Agenda: React.FC = () => {
  const user = useAppSelector(state => state.app.user);
  const history = useHistory();
  const location = useLocation();
  const [filtros, setFiltros] = useState<IAgendaFiltros>(getDefaultFiltros({}));
  const [selectedTab, setSelectedTab] = useState<string>();
  const locationSearch = location.search;
  const tab = getTabFromUrl(locationSearch);

  useEffect(() => {
    if (locationSearch) {
      const query = qs.parse(locationSearch, {ignoreQueryPrefix: true});
      const {tipo_aplicacoes, tipo_semeadura, cliente, dias} = query;
      const nFiltros: any = getDefaultFiltros({});

      if (tipo_aplicacoes)
        nFiltros.tipo_aplicacoes = true;

      if (tipo_semeadura)
        nFiltros.tipo_semeadura = true;

      if (dias)
        nFiltros.dias = Number.parseInt(dias.toString());

      if (cliente) {
        // inverter default
        assign(nFiltros, {colecao_fazendas: false, colecao_veterinarios: false, colecao_lojas: false});
        cliente.toString().split(',').forEach(i => {
          switch (i) {
            case "fazendas":
            case "lojas":
            case "veterinarios":
              nFiltros[`colecao_${i}`] = true;
              break;
          }
        })
      }

      setFiltros(nFiltros);
    } else {
      setFiltros(getDefaultFiltros({}));
    }
  }, [locationSearch]);

  useIonViewWillEnter(() => {
    if (!tab) {
      history.push('/agenda?tab=proximos');
    } else {
      setSelectedTab(tab);
    }
  });

  // set selectedTab from url
  useEffect(() => {
    if (tab && !selectedTab) {
      setSelectedTab(tab);
    }
  }, [tab, selectedTab]);

  const onChangeNav = (_tab: string) => {
    const queryString = buildQueryStringFromAgendaFiltros(filtros, {tab: _tab});
    setSelectedTab(_tab);
    history.push(`/agenda?${queryString}`);
  }

  const tabs:any[] = [
    {
      tab: "atrasados",
      icon: alertCircleOutline,
      label: "Atrasados",
    },
    {
      tab: "proximos",
      icon: document,
      label: "Próximos",
    },
    {
      tab: "passados",
      icon: clipboard,
      label: "Concluídos",
    },
  ];

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton/>
          </IonButtons>
          <IonTitle>
            Próximos contatos
          </IonTitle>
          <IonIcon
            icon={home}
            slot="primary"
            class="pr-3 text-2xl"
            onClick={() => history.push('/home')}
          />
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {selectedTab === 'proximos' &&
          <AgendaProximos
            user={user}
            filtros={filtros}
            setFiltros={setFiltros}
          />
        }
        {selectedTab === 'passados' &&
          <AgendaAnteriores
            user={user}
            filtros={filtros}
            setFiltros={setFiltros}
          />
        }
        {selectedTab === 'atrasados' &&
          <AgendaAtrasados
            user={user}
            filtros={filtros}
            setFiltros={setFiltros}
          />
        }
      </IonContent>
      {selectedTab &&
        <NavFooter
        value={selectedTab}
        onChange={onChangeNav}
        tabs={tabs}
      />
      }
    </IonPage>
  );
}

export default Agenda;
